module.exports = __webpack_public_path__ + "teqbahn-assets/media/nairobi2.5d181297.png";